import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSocureIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 48,
			rx: 8,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.0286 19.9429L16 27.9714L24.0286 36L32.0571 27.9714L24.0286 19.9429Z",
			fill: "#FF8200"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.0286 12L16 20.0286L24.0286 28.0571L32.0571 20.0286L24.0286 12Z",
			fill: "#FF6900"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.0571 27.9714L24.0286 28.0571L28.0857 24L32.0571 27.9714Z",
			fill: "#141B4D"
		})
	]
});
export default SvgSocureIcon;
